import React, { Component } from 'react';
import './App.css';
import Main from './components/Main'
import { Switch, Route } from 'react-router-dom';
import Login from './components/Login/Login';
import HttpsRedirect from 'react-https-redirect';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import constants from './components/constants';


const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: constants.COLOR_PRIMARY,
      dark: constants.COLOR_PRIMARY,
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

class App extends Component {
  render() {
    return (
      <HttpsRedirect>
        <MuiThemeProvider theme={theme}>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/" component={Main} />
          </Switch>
        </MuiThemeProvider>
      </HttpsRedirect> 
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js